import { render, staticRenderFns } from "./ContextHelp.vue?vue&type=template&id=681270c4&scoped=true&"
import script from "./ContextHelp.vue?vue&type=script&lang=js&"
export * from "./ContextHelp.vue?vue&type=script&lang=js&"
import style0 from "./ContextHelp.vue?vue&type=style&index=0&id=681270c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681270c4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VBtn,VIcon,VNavigationDrawer})
